import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue";
import { computed } from 'vue';
import { activeHint, activeSnackbar } from '@/composables/useAnchorHint';
export default {
  __name: 'AnchorHintHost',
  setup(__props) {
    const hint = computed(() => activeHint.value);
    const snackbar = computed(() => activeSnackbar.value);
    const hintStyle = computed(() => {
      const current = hint.value;
      if (!current) return {};
      const maxWidth = Number.isFinite(current.maxWidth) && current.maxWidth > 0 ? `${current.maxWidth}px` : '360px';
      const width = Number.isFinite(current.width) && current.width > 0 ? `${current.width}px` : undefined;
      return {
        position: 'fixed',
        zIndex: 99999,
        top: `${current.top}px`,
        left: `${current.left}px`,
        width,
        maxWidth,
        transform: 'none',
        color: current.color,
        fontSize: current.fontSize,
        fontWeight: current.fontWeight
      };
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(_Transition, {
        name: "ds-anchor-hint-fade"
      }, {
        default: _withCtx(() => [hint.value ? (_openBlock(), _createElementBlock("span", {
          key: 'a-' + hint.value.id,
          class: "ds-anchor-hint",
          role: "status",
          "aria-live": "polite",
          style: _normalizeStyle(hintStyle.value)
        }, _toDisplayString(hint.value.text), 5)) : _createCommentVNode("", true)]),
        _: 1
      }), _createVNode(_Transition, {
        name: "ds-anchor-snackbar"
      }, {
        default: _withCtx(() => [snackbar.value ? (_openBlock(), _createElementBlock("div", {
          key: 's-' + snackbar.value.id,
          class: "ds-anchor-snackbar",
          role: "status",
          "aria-live": "polite"
        }, _toDisplayString(snackbar.value.text), 1)) : _createCommentVNode("", true)]),
        _: 1
      })]);
    };
  }
};